<template>
    <Modal v-model="visible" @on-ok="ok" :loading="modalLoading" :closable="!modalLoading"
        :mask-closable="!modalLoading" :okText="getTranslation('m063')" cancelText="" :title="getTranslation('b191')"
        width="80">
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('b005') }}</div>
            <Row class="limit-line" type="flex">
                <Col flex="1" class="desc-field">
                <Row type="flex">
                    <Col flex="1" class="left-program">{{ getTranslation('b006') }}</Col>
                    <Col flex="1" v-html="selectLibrary.ProgramId">
                    </Col>
                </Row>
                </Col>
                <Col flex="1" class="desc-field">
                <Row type="flex">
                    <Col flex="1" class="left-program">{{ getTranslation('b008') }}</Col>
                    <Col flex="1"><Input type="text" class="input-field" :value="selectLibrary.CrrMinWeld1"></Input>
                    </Col>
                </Row>
                </Col>
                <Col flex="1" class="desc-field">
                <Row type="flex">
                    <Col flex="1" class="left-program">{{ getTranslation('b010') }}</Col>
                    <Col flex="1"><Input type="text" class="input-field" :value="selectLibrary.CrrMinWeld2"></Input>
                    </Col>
                </Row>
                </Col>
                <Col flex="1" class="desc-field">
                <Row type="flex">
                    <Col flex="1" class="left-program">{{ getTranslation('b012') }}</Col>
                    <Col flex="1"><Input type="text" class="input-field" :value="selectLibrary.CrrMinWeld3"></Input>
                    </Col>
                </Row>
                </Col>
                <Col flex="1" class="desc-field">
                <Row type="flex">
                    <Col flex="1" class="left-program">{{ getTranslation('b014') }}</Col>
                    <Col flex="1">
                    <Select :transfer="true" class="input-field" :value="selectLibrary.OptPowerControl">
                        <Option v-for="(item, index) in powControlList" :value="index" :key="index">{{ item }}</Option>
                    </Select>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row class="limit-line" type="flex">
                <Col flex="1" class="desc-field">
                <Row type="flex">
                    <Col flex="1" class="left-program">{{ getTranslation('b007') }}</Col>
                    <Col flex="1"><Input type="text" class="input-field" :value="selectLibrary.WeldProgram"
                        maxlength="15" /></Col>
                </Row>
                </Col>
                <Col flex="1" class="desc-field">
                <Row type="flex">
                    <Col flex="1" class="left-program">{{ getTranslation('b009') }}</Col>
                    <Col flex="1"><Input type="text" class="input-field" :value="selectLibrary.CrrMaxWeld1"></Input>
                    </Col>
                </Row>
                </Col>
                <Col flex="1" class="desc-field">
                <Row type="flex">
                    <Col flex="1" class="left-program">{{ getTranslation('b011') }}</Col>
                    <Col flex="1"><Input type="text" class="input-field" :value="selectLibrary.CrrMaxWeld2"></Input>
                    </Col>
                </Row>
                </Col>
                <Col flex="1" class="desc-field">
                <Row type="flex">
                    <Col flex="1" class="left-program">{{ getTranslation('b013') }}</Col>
                    <Col flex="1"><Input type="text" class="input-field" :value="selectLibrary.CrrMaxWeld3"></Input>
                    </Col>
                </Row>
                </Col>
                <Col flex="1" class="desc-field">
                </Col>
            </Row>
        </Card>
        <!-- 分隔区域 -->
        <div class="separator-section">
            <div class="separator-line"></div>
        </div>
        <div class="other-line">
            <Row type="flex" class="row-line">
                <Col flex="1">
                </Col>
                <Col flex="2">{{ getTranslation('b018') }}</Col>
                <Col flex="2">{{ getTranslation('b019') }}</Col>
                <Col flex="2">{{ getTranslation('b020') }}</Col>
                <Col flex="2">{{ getTranslation('b021') }}</Col>
                <Col flex="2">{{ getTranslation('b022') }}</Col>
                <Col flex="2">{{ getTranslation('b023') }}</Col>
                <Col flex="2">{{ getTranslation('b024') }}</Col>
                <Col flex="2">{{ getTranslation('b025') }}</Col>
                <Col flex="2">{{ getTranslation('b026') }}</Col>
                <Col flex="2">{{ getTranslation('b027') }}</Col>
                <Col flex="2">{{ getTranslation('b028') }}</Col>
                <Col flex="2">{{ getTranslation('b029') }}</Col>
                <Col flex="2">{{ getTranslation('b030') }}</Col>
                <Col flex="2">{{ getTranslation('b031') }}</Col>
                <Col flex="2">{{ getTranslation('b032') }}</Col>
                <Col flex="1">
                </Col>
            </Row>
            <Row type="flex" class="row-line">
                <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-mode.png')" /></Col>
                <Col flex="10">
                </Col>
                <Col flex="2" class="no-wrap"><Select :transfer="true" size="small" class="input" :value="selectLibrary.OptWeld1">
                    <Option v-for="(item, index) in weldList" :value="index" :key="index">{{ item }}</Option>
                </Select></Col>
                <Col flex="2">
                </Col>
                <Col flex="2" class="no-wrap"><Select :transfer="true" size="small" class="input" :value="selectLibrary.OptWeld2">
                    <Option v-for="(item, index) in weldList" :value="index" :key="index">{{ item }}</Option>
                </Select></Col>
                <Col flex="2">
                </Col>
                <Col flex="2" class="no-wrap"><Select :transfer="true" size="small" class="input" :value="selectLibrary.OptWeld3">
                    <Option v-for="(item, index) in weldList" :value="index" :key="index">{{ item }}</Option>
                </Select></Col>
                <Col flex="11">
                </Col>
            </Row>
            <Row type="flex" class="row-line">
                <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-crr.png')" /></Col>
                <Col flex="4">
                </Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.CrrPreWeld" /></Col>
                <Col flex="4">
                </Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.CrrWeld1" /></Col>
                <Col flex="2">
                </Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.CrrWeld2" /></Col>
                <Col flex="2">
                </Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.CrrWeld3" /></Col>
                <Col flex="4">
                </Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.CrrPostWeld" /></Col>
                <Col flex="4">
                </Col>
                <Col flex="1">KA</Col>
            </Row>
            <Row type="flex" class="row-line">
                <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-time.png')" /></Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.TimPrePress" />
                </Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.TimMorePress" />
                </Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.TimPreWeld" />
                </Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.TimCold0" /></Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.TimAscentWeld" />
                </Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.TimWeld1" /></Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.TimCold1" /></Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.TimWeld2" /></Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.TimCold2" /></Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.TimWeld3" /></Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.TimDescendWeld" />
                </Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.TimCold3" /></Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.TimPostWeld" />
                </Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.TimKeep" /></Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.TimRelease" /></Col>
                <Col flex="1">ms</Col>
            </Row>
            <Row type="flex" class="row-line">
                <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-pss.png')" /></Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.PssPrePress" />
                </Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.PssMorePress" />
                </Col>
                <Col flex="10">
                </Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.PssWeld2" /></Col>
                <Col flex="12">
                </Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.PssRelease" /></Col>
                <Col flex="1">KN</Col>
            </Row>
            <Row type="flex" class="row-line">
                <Col flex="13">
                </Col>
                <Col flex="2">{{ getTranslation('b037') }}</Col>
                <Col flex="2"><Input type="text" size="small" class="input" :value="selectLibrary.NumWeldPulse2" />
                </Col>
                <Col flex="15">
                </Col>
            </Row>
        </div>
    </Modal>
</template>
<script>
/* eslint-disable */
import { Row, Col, Modal, Card, Select, Option, Input } from "view-design"
import { mapGetters } from 'vuex'
export default {
    name: 'LibraryQuery', // 组件名称
    components: {
        Row, Col, Modal, Card, Select, Option, Input
    },
    props: {
        selectLibrary: {
            type: Object,
            default: function () { return {} }
        },
        propVisible: Boolean,
    },
    data() {
        return {

            mac: 0,
            modalLoading: false,
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        SwitchList() {
            return [
                this.getTranslation("k048"),
                this.getTranslation("k049"),
            ]
        },
        visible: {
            get() { return this.propVisible },
            set(val) { this.$emit('input', val) }
        },
        powControlList() {
            return [
                this.getTranslation("b016"),
                this.getTranslation("b017"),
                this.getTranslation("b015"),
            ]
        },
        weldList() {
            return [
                this.getTranslation("b016"),
                this.getTranslation("b017"),
            ]
        },

    },
    watch: {

    },

    created() {
        this.init();
    },
    methods: {
        init() {
            this.mac = this.$route.query.mac


        },
        ok() {

        }
    },

}
</script>

<style scoped>
@import url('../../../assets/style/list.css');
@import url('../../../assets/style/tab.css');

.other-img {
    width: 14px;
}

.input {
    width: 90%;
}

.row-line {
    margin: 5px 0;
}
</style>